<div class="wrapper checkout box-container">
    <div class="checkout-title">
        <h2 class="category-heading">Checkout</h2>
        @if (userService.balance()) {
            <div class="user-points-balance body-0">
                {{ userService.points() | appDigitsGrouping }} available {{ rewardName() }}
            </div>
        } @else {
            <div class="user-points-balance--skeleton">
                <ng-container *ngTemplateOutlet="skeletonService.rectangleTemplate()"></ng-container>
            </div>
        }
    </div>
    <div class="checkout-content">
        <div class="checkout-sections">
            <cdk-accordion class="accordion">
                @for (section of checkoutSections(); track section.title; let index = $index) {
                    <cdk-accordion-item
                        class="accordion-item"
                        #accordionItem
                        [ariaLabel]="'Checkout ' + section.title"
                        [expanded]="index === expandedActiveStep()"
                        [ngClass]="{ expanded: expandedActiveStep() === index }"
                    >
                        <div class="accordion-item-header">
                            <h2 [id]="section.title" class="subheading-2" (click)="$event.stopPropagation()">
                                {{ section.title }}
                            </h2>
                            @if (
                                ((section.step === checkoutStepEnum.Shipping && this.isShippingSubmitted()) ||
                                    (section.step === checkoutStepEnum.PaymentOptions &&
                                        this.isPaymentOptionsSubmitted())) &&
                                expandedActiveStep() !== index &&
                                index < expandedActiveStep()
                            ) {
                                <mat-icon
                                    svgIcon="ico_edit"
                                    [ariaLabel]="section.editButtonLabel"
                                    [attr.aria-hidden]="false"
                                    (libAccessibleClick)="setExpandedActiveStep(section.step)"
                                />
                            }
                        </div>
                        <div
                            class="accordion-item-body"
                            ariaLive="assertive"
                            [ariaLabel]="section.title"
                            [style.display]="section.step === expandedActiveStep() ? '' : 'none'"
                        >
                            <ng-container *ngTemplateOutlet="section.template"></ng-container>
                        </div>
                    </cdk-accordion-item>
                }
            </cdk-accordion>
        </div>
        <div class="cart-summary" [class.visible]="expandedActiveStep() !== checkoutStepEnum.OrderReview">
            <cdk-accordion class="accordion">
                <cdk-accordion-item class="accordion-item expanded" #accordionItem2="cdkAccordionItem">
                    <div class="accordion-item-header">
                        <h2 class="subheading-2">Cart Summary</h2>
                    </div>
                    <div class="accordion-item-body" role="region" [style.display]="true">
                        <ng-container *ngTemplateOutlet="summaryBox"></ng-container>
                    </div>
                </cdk-accordion-item>
            </cdk-accordion>
        </div>
    </div>
</div>

<ng-template #summaryBox>
    <div class="summary-box">
        @if (productCard()) {
            <div class="items">
                @for (product of filteredProcessedProducts(); track product.lineNumber ?? product.productId) {
                    <lib-cart-summary-item [product]="product">
                        @if (product.appleCareItem) {
                            <app-apple-care-listing
                                cart-summary-apple-care
                                [appleCareItem]="product.appleCareItem"
                            ></app-apple-care-listing>
                        }
                    </lib-cart-summary-item>
                }
            </div>
            <div class="summary-totals">
                <lib-cart-total-info [data]="productCard()" />
                <p class="summary-returns-policy body-2">No returns or refunds.</p>
            </div>
        } @else {
            <div class="summary-box--skeleton">
                <ng-container *ngTemplateOutlet="skeletonService.rectangleTemplate()"></ng-container>
            </div>
        }
    </div>
</ng-template>

<ng-template #shippingSectionTemplate>
    <lib-checkout-shipping-information
        (emailChange)="onEmailChange($event)"
        (submitAction)="onSubmitShippingInformation($event)"
    />
</ng-template>

<ng-template #paymentOptionsTemplate>
    <app-checkout-payment-options
        [email]="email()"
        [pointsAvailable]="userService.points()"
        [productCard]="productCard()"
        [selectedAddress]="selectedShippingAddress()"
        (cardType)="cardTypeChange($event)"
        (changePayloadIdInfo)="onPayerInfoChange($event)"
        (pointsChange)="onRedeemPointsChange($event)"
        (submitAction)="onSubmitPaymentOptions($event)"
    />
</ng-template>

<ng-template #orderReviewTemplate>
    <lib-checkout-order-review
        [cardType]="cardType()"
        [email]="email()"
        [isPlaceOrderPending]="isPlaceOrderPending()"
        [pointsAvailable]="userService.points()"
        [pointsRedeem]="pointsRedeem()"
        [productCard]="productCard()"
        [shippingAddress]="selectedShippingAddress()"
        [totalLabel]="'Total'"
        [usdRedeem]="willBeBilledUsd()"
        (submitAction)="onSubmitOrderReview()"
    />
</ng-template>
